import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useLocalJson } from '../../../helper/utils/cache';
import { doHandleGetBrands } from '../../../redux/onlineSales/onlineSales.actions';
import pages from '/src/assets/data/pages.json';

export default function usePages() {
    const dispatch = useDispatch();
    const [params, _] = useSearchParams();

    const outlet = useLocalJson('outlet');
    const brand = useLocalJson('brand');
    const page = useLocalJson('page');
    const product = useLocalJson('product');
    const outlets = brand['outlets'] || [];

    const outletCode = String(params.get('outlet') || '')
        .trim()
        .toUpperCase();
    const brandCode = String(params.get('brand') || '')
        .trim()
        .toUpperCase();

    const productDate = String(params.get('date') || '')
        .trim()
        .toUpperCase();

    const productId = String(params.get('productId') || '')
        .trim()
        .toUpperCase();

    const productType = String(params.get('type') || '')
        .trim()
        .toUpperCase();

    const isShowDetailProduct = String(params.get('isShowDetail') || '').trim() == 'true';

    const { loadingBrand, brands } = useSelector((state) => state?.onlineSales);

    const handleGetBrand = (id, onSuccess) => {
        dispatch(doHandleGetBrands(id, onSuccess));
    };

    const isLoading = loadingBrand;

    return { outlet, brand, brands, page, pages, outlets, product, isLoading, outletCode, brandCode, productDate, productId, isShowDetailProduct, productType, handleGetBrand };
}
